import QRCode from "qrcode";

import { canvasToBlob, downloadBlob } from "@/common/lib/images";

// Negro sobre blanco fijo: el QR se imprime, no sigue el tema del portal.
const QR_OPTIONS = {
    errorCorrectionLevel: "M",
    margin: 2,
    color: { dark: "#000000", light: "#ffffff" }
};

// Tamaño del PNG descargado: el QR en pantalla mide unos 250 px y saldría
// pixelado al imprimirlo en grande, por eso se genera aparte.
const DOWNLOAD_SIZE_PX = 1024;

export const renderQrToCanvas = (canvas, value, width) =>
    QRCode.toCanvas(canvas, value, { ...QR_OPTIONS, width });

// Sin slug (ecommercePro) se usa el dominio de la URL.
export const buildQrFilename = (url, tenantSlug) =>
    `qr-${tenantSlug || new URL(url).hostname.replace(/^www\./, "")}`;

export const downloadQrImage = async (value, filename) => {
    const canvas = document.createElement("canvas");
    await renderQrToCanvas(canvas, value, DOWNLOAD_SIZE_PX);
    const blob = await canvasToBlob(canvas);
    downloadBlob(blob, `${filename}.png`);
};
